import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { Title } from 'components/layout'
import { Input, Select, Textarea } from 'components/fields'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { changeValidation } from 'models/assessors'
import { apiCodeLists } from 'helpers/decorators/api'
import { ROLES } from 'constants/enums'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { checkAssessorEmailAvailability } from '../../../../redux/modules/api/asyncValidations'


const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  const isAssessorManagementEnabled = get(props, 'isAssessorManagementEnabled')

  if (!isAssessorManagementEnabled) {
    return new Promise(resolve => resolve())
  }

  const activityCategoryId = get(values, 'activityCategory.id')

  if (!get(values, 'assessorEmail') || (!activityCategoryId || activityCategoryId === 'OTHER')) {
    return new Promise(resolve => resolve())
  }

  const email = get(values, 'assessorEmail')

  const orgId = get(props, 'orgId')

  return email && orgId && activityCategoryId && props.checkAssessorEmailAvailability(email, orgId, activityCategoryId)
      .then(body => {
        if (!get(body, 'body.available')) {
          const bodyObj = get(body, 'body')

          let assessor = ''

          get(bodyObj, 'assessorList').forEach(a => {
            assessor += get(a, 'name') + ' '
          })
          // eslint-disable-next-line
          throw {
            assessorEmail:
                {
                  text: `Assessor ${assessor} already exists, select him/her from the list.`,
                  intlKey: 'errors.assessor_already_exists'
                }

          }
        }
      })
}

@apiCodeLists(['titles'])
@connect(({ auth }) => ({
  userType: auth.organization.userType
}), { checkAssessorEmailAvailability })
@form({
  form: 'change-assessor-form',
  initialProps: 'data',
  validate: changeValidation,
  asyncValidate
})
class AssessorChange extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    codeLists: PropTypes.object.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    userType: PropTypes.string,
    data: PropTypes.object,
    isAssessorManagementEnabled: PropTypes.bool,
    isOthersSubCategory: PropTypes.bool,
    isSubCategorySelected: PropTypes.bool,
    assessors: PropTypes.array,
    values: PropTypes.object,
    initialize: PropTypes.func,
    orgId: PropTypes.number,
    checkAssessorEmailAvailability: PropTypes.func
  }

  componentWillMount = () => {
    const { data, isAssessorManagementEnabled } = this.props

    if (isAssessorManagementEnabled && get(data, 'assessor.id')) {
      const newAssessorId = get(data, 'assessor.id') ?? 0

      const newData = { ...data, setupAssessorId: newAssessorId }
      this.props.initialize(newData)
    }
  }

  handleAssessorChange = () => {
    this.props.change('assessorTitle', null)
    this.props.change('assessorName', null)
    this.props.change('assessorEmail', null)
    this.props.change('assessorPhone', null)
    this.props.change('assessorRelevantExperience', null)
  }

  render() {
    const {
      handleSubmit,
      submitting,
      codeLists,
      data,
      userType,
      isAssessorManagementEnabled,
      isOthersSubCategory,
      isSubCategorySelected,
      assessors,
      values
    } = this.props

    const showReason = data && data.assessor && userType === ROLES.LEADER.u

    const assessorSetupValue = get(values, 'setupAssessorId')

    const isNoneOfTheseSubCategory = assessorSetupValue === 0

    return (
      <form onSubmit={handleSubmit(this.props.onSubmit)}>
        <Title h2 intlKey="moduleTitle.assessor_detail">
          Assessor detail
        </Title>

          {isAssessorManagementEnabled && !isOthersSubCategory && <div className="row">
            <div className="col-xs-12">
              <Select
                  name="setupAssessorId"
                  label=""
                  intlKey=""
                  options={assessors}
                  disabled={isOthersSubCategory}
                  onInputChange={() => this.handleAssessorChange()}
              />
            </div>
          </div>}

          {isAssessorManagementEnabled && isOthersSubCategory && <div style={{ marginBottom: '10px' }}><FormattedMessage
              id="label.assessor_disabled_for_other_activity"
              defaultMessage="Assessor selection is disabled for other activity."
          /></div>}
        {(!isAssessorManagementEnabled || (isNoneOfTheseSubCategory && isSubCategorySelected)) && <div>
        <div className="row">
          <div className="col-xs-6">
            <Select
              label="Title"
              intlKey="label.title"
              name="assessorTitle"
              options={codeLists.titles.list}
            />
          </div>
          <div className="col-xs-6">
            <Input label="Name" intlKey="label.name" name="assessorName" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Input label="Email" intlKey="label.email" name="assessorEmail" />
          </div>
          <div className="col-xs-6">
            <Input label="Phone" intlKey="label.phone" name="assessorPhone" />
          </div>
        </div>
        {showReason && (
          <div className="row">
            <div className="col-xs-12">
              <Textarea
                label="Reason for changing the assessor"
                intlKey="label.reason_for_changing_assessor"
                name="reasonForChangingAssessor"
              />
            </div>
          </div>
        )}
        </div>}

        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              secondary
              intlKey="button.close"
              onClick={this.props.onRequestClose}
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              intlKey="button.change"
              isLoading={submitting}
              disabled={isAssessorManagementEnabled && (isOthersSubCategory || assessorSetupValue === null)}
            >
              Change
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default AssessorChange

